export class StringUtil {

    public static sort(s1: string | undefined, s2: string | undefined): number {
        if (!s1) {
            s1 = "";
        }
        if (!s2) {
            s2 = "";
        }
        return s1.localeCompare(s2);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static contem(texto: any, textoContido: string): boolean {
        const textoStr = '' + texto;
        return textoStr.indexOf(textoContido) >= 0;
    }

    static contemQuebraLinha(texto: string): boolean {
        if (!texto) {
            return false;
        }
        return StringUtil.contem(texto, '\n');
    }

    static removerLinhasVazias(texto: string): string {
        return texto ? texto.split('\n').filter(line => line.trim() !== '').join('\n') : "";
    }

    static removerTagsHtml(input: string): string {
        if (!input) {
            return '';
        }
        return input.replace(/<[^>]*>/g, '');
    }

    static quebrarTextoEmLinhas(texto: string): string[] {
        if (!texto) {
            return [];
        }
        return texto.split('\n');
    }

    static isEmpty(value: string | null | undefined): boolean {
        return value === null || value === undefined || value.trim().length === 0;
      }

    static isNotEmpty(value: string | null | undefined): boolean {
        return !this.isEmpty(value);
    }
}